export default __webpack_public_path__ + "static/hirahata-clinic-signboard-9487fc3bf3676ba4ee579dc2b330c0f7.jpg";